export const calculateFontSize = (text, isWord = false) => {
  if (typeof text !== 'string' || text.length === 0) {
    return isWord ? '24px' : '16px';
  }

  const baseSize = isWord ? 48 : 24;
  const length = text.length;

  if (length <= 10) return `${baseSize}px`;
  if (length <= 20) return `${baseSize * 0.8}px`;
  if (length <= 30) return `${baseSize * 0.6}px`;
  if (length <= 40) return `${baseSize * 0.5}px`;
  return `${baseSize * 0.4}px`;
};

export const handleSwipeEnd = (offset, isAnswerOnRight, onSwipe) => {
  if (Math.abs(offset) > 75) {
    const isRight = offset > 0;
    const isCorrect = isRight === isAnswerOnRight;
    onSwipe(isCorrect);
    return true;
  }
  return false;
};

export const getSwipeDirection = (startX, currentX) => {
  if (startX === null) return null;
  return currentX - startX > 0 ? 'right' : 'left';
};
